/**
 * Helpers puros sobre o `Criterion` das badges — sem React. Mantém a
 * lógica testável fora do BadgeFormDialog (componente grande, caro de
 * montar em teste).
 */

import type { Criterion } from './types'

/**
 * `true` quando o critério é `specific_*` mas ainda não tem alvo
 * selecionado. O back valida `targetId` com `z.string().min(1)` —
 * enviar vazio dá 400, então o submit é travado client-side.
 */
export function criterionTargetMissing(criterion: Criterion): boolean {
  return (
    (criterion.type === 'specific_episode' ||
      criterion.type === 'specific_module' ||
      criterion.type === 'specific_course') &&
    !criterion.targetId
  )
}
